import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings } from '@styles/index';
import { getIsDarkModeOn } from '@stores/selectors/darkModeStatusSelectors';
import useDarkModeStatus from '@stores/useDarkModeStatus';

const HeaderWrapper = styled.div`
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_12B};
  background-color: var(--color-base-1);
  grid-column: span 18;
  border-radius: ${Spacings.SPACING_2B};
`;

const BreadCrumbsWrapper = styled.div`
  display: flex;
`;

const StyledSkeleton = styled(Skeleton)`
  ${({ $isDarkModeOn }) =>
    $isDarkModeOn && 'background-color: var(--color-base-1);'}
  border-radius: ${Spacings.SPACING_2B};
`;

const RectStyledSkeleton = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <StyledSkeleton variant="rect" {...props} />
);

const BackButton = styled(RectStyledSkeleton)`
  box-shadow: ${boxShadowGenerator()};
  margin-right: ${Spacings.SPACING_3B};
`;

const BreadCrumb = styled(RectStyledSkeleton)`
  transform: skew(-20deg);
  height: ${Spacings.SPACING_8B};
  box-shadow: ${({ theme }) =>
    boxShadowGenerator({
      yOffset: Spacings.SPACING_1B,
      blur: Spacings.SPACING_4B,
      theme
    })};
  margin: auto ${Spacings.SPACING_6};
`;

const Title = styled(RectStyledSkeleton)`
  margin-top: ${Spacings.SPACING_6B};
`;

const HeaderNavBar = ({ breadcrumbsCount, className, title }) => {
  const isDarkModeOn = useDarkModeStatus(getIsDarkModeOn);
  return (
    <HeaderWrapper className={className}>
      <BreadCrumbsWrapper>
        <BackButton
          $isDarkModeOn={isDarkModeOn}
          width={Spacings.SPACING_8B}
          height={32}
        />
        {[...new Array(breadcrumbsCount).keys()].map((item) => (
          <BreadCrumb
            $isDarkModeOn={isDarkModeOn}
            key={item}
            width="86px"
            height={32}
          />
        ))}
      </BreadCrumbsWrapper>
      {title && <Title $isDarkModeOn={isDarkModeOn} height={38} />}
    </HeaderWrapper>
  );
};

HeaderNavBar.propTypes = {
  breadcrumbsCount: PropTypes.number.isRequired,
  className: PropTypes.string,
  title: PropTypes.bool
};

HeaderNavBar.defaultProps = {
  className: '',
  title: true
};

export default HeaderNavBar;
